import request from '@/utils/request'
export const getVisitPlanList = (data) => {
    return request({
        url: '/msv/query',
        method: 'post',
        data: data
    });
}
export const addVisitPlanInit = () => {
    return request({
        url: '/msv/msvNo',
        method: 'post',
    });
}
export const visitPlanDetailAddSeach = (data) => {
    return request({
        url: '/supplier/querySupplierWithProductType',
        method: 'post',
        data: data
    });
}
export const visitPlanAdddraft = (data) => {
    return request({
        url: '/msv/draft',
        method: 'post',
        data: data
    });
}
export const visitPlanAdddSubmit = (data) => {
    return request({
        url: '/msv/submit',
        method: 'post',
        data: data
    });
}
export const visitPlanAddInactive = (data) => {
    return request({
        url: '/msv/inactive',
        method: 'post',
        data: data
    });
}
export const visitReportInactive = (data) => {
    return request({
        url: '/msv-report/inactive',
        method: 'post',
        data: data
    });
}
export const getVisitPlanDetail = (data) => {
    return request({
        url: '/msv/queryDetail',
        method: 'post',
        data: data
    });
}
export const getVisitPlanLogList = (data) => {
    return request({
        url: '/change-log/list',
        method: 'post',
        data: data
    });
}
export const exportVisitPlan = (data) => {
    return request({
        url: '/msv/export',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        responseType: 'blob',
        data: data
    });
}
export const exportVisitReportPlan = (data) => {
    return request({
        url: '/msv-report/export',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        responseType: 'blob',
        data: data
    });
}

export const getVisitReportList = (data) => {
    return request({
        url: '/msv-report/queryData',
        method: 'post',
        data: data
    });
}
export const terminateMsvResport = (data) => {
    return request({
        url: '/msv-report/terminate',
        method: 'post',
        data: data
    });
}
export const PDFfileUpload = (data) => {
    return request({
        url: '/msv-report/uploadMsvReportPdf',
        method: 'POST',
        headers: {
            'Content-Type': 'multipart/form-data; charset=UTF-8'
        },
        data: data
    })
}
export const saveReport = (data) => {
    return request({
        url: '/msv-report/save',
        method: 'post',
        data: data
    });
}
export const submitReport = (data) => {
    return request({
        url: '/msv-report/submit',
        method: 'post',
        data: data
    });
}
export const addVisitPlanReportInit = () => {
    return request({
        url: '/msv-report/queryMaxReportNo',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
    });
}
export const reportDetail = (data) => {
    return request({
        url: '/msv-report/queryDetail',
        method: 'post',
        data: data
    });
}
export const downLoadZipCQS = (data) => {
    return request({
        url: '/msv-report/downloadZip',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        responseType: 'blob',
        data: data
    });
}
export const downLoadZipSP = (data) => {
    return request({
        url: '/file/downloadZip',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        responseType: 'blob',
        data: data
    });
}
export const getVisitReportListSP = (data) => {
    return request({
        url: '/spmsv-report/queryData',
        method: 'post',
        data: data
    });
}
export const saveSP = (data) => {
    return request({
        url: '/spmsv-report/save',
        method: 'post',
        data: data
    });
}
export const submitSP = (data) => {
    return request({
        url: '/spmsv-report/submit',
        method: 'post',
        data: data
    });
}
export const approvalPass = (data) => {
    return request({
        url: '/msv-report/audit',
        method: 'post',
        data: data
    });
}
export const approvalRefuse = (data) => {
    return request({
        url: '/msv-report/audit',
        method: 'post',
        data: data
    });
}
export const getVisitPlanDetailInit = (data) => {
    return request({
        url: '/msv/queryMsvDetailById',
        method: 'post',
        data: data,
    });
}
export const getAuditLogs = (data) => {
    return request({
        url: '/msv-report/queryDetailWithAuditLogs',
        method: 'post',
        data: data
    });
}
export const updateMsvDetailMonth = (data) => {
    return request({
        url: '/msv/updateMsvDetailMonth',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    });
}
export const getCategoryValue = (data) => {
        return request({
            url: '/supplier/queryCategoryLevel',
            method: 'post',
            data: data,
        });
    }
    //获取Report to（Supplier）
export const getUsersEmail = (data) => {
    return request({
        url: '/user/spList',
        method: 'post',
        data: data,
    });
}
export const getVisitReportLogList = (data) => {
    return request({
        url: '/change-log/msvReportlist',
        method: 'post',
        data: data
    });
}
export const saveMsvReportFileLogs = (data) => {
    return request({
        url: '/change-log/saveMsvReportFileLogs',
        method: 'post',
        data: data
    });
}
export const getUsers = (data) => {
    return request({
        url: '/user/mcdList',
        method: 'post',
        data: data
    });
}
export const changeFileName = (data, id) => {
    return request({
        url: 'file/changeFileName/' + id,
        method: 'post',
        data: data
    });
}